import KliraProduct from '../obj/KliraProduct.js';

// pull products from local storage and create objects from them
let availableSubscriptionPlans = localStorage.getItem('available-subscription-plans')
    ? JSON.parse(localStorage.getItem('available-subscription-plans'))
    : []

let availableCharges = localStorage.getItem('available-charges')
    ? JSON.parse(localStorage.getItem('available-charges'))
    : []



// register all products
window.products = {
    objects: [

    ],

    load() {
        let products = this;

        availableSubscriptionPlans.forEach(function(subscriptionPlan) {
            subscriptionPlan.items.forEach(function(subscriptionAddon) {
                let product = new KliraProduct();

                product.id = subscriptionAddon.addon_id;
                product.chargebeePlanId = subscriptionPlan.plan_id;
                product.chargebeeAddOnId = subscriptionAddon.addon_id;
                product.name = subscriptionAddon.name;
                product.price = subscriptionAddon.price;
                product.subscription_length = subscriptionAddon.subscription_length;
                
                if (subscriptionAddon.is_night_cream) {
                    product.isNightCream = true;
                    product.isSubscription = true;
                    product.imageUrl = 'https://klira.skin/wp-content/uploads/2025/12/SPECIAL-1.jpg';
                } else if (subscriptionAddon.is_body) {
                    product.isBody = true;
                    product.isSubscription = true;
                    product.imageUrl = 'https://klira.skin/wp-content/uploads/2024/05/body-product.png';
                }else if (subscriptionAddon.is_day_script) {
                    product.journeyMap = {
                      201: {
                        label: "OILY & HYPERPIGMENTED SKINSIZES",
                        image:
                          "https://stg-api.klira.skin/uploads/69dc64b9a2fa561784a39c375877fa69d2e18f86_1_e21d222d8f.png",
                      },
                      202: {
                        label: "OILY & NON-HYPERPIGMENTED SKINSIZES",
                        image:
                          "https://stg-api.klira.skin/uploads/oily_and_nonhyperpigmented_68fac3cabc.png",
                      },
                      203: {
                        label: "DRY & HYPERPIGMENTED SKINSIZES",
                        image:
                          "https://stg-api.klira.skin/uploads/dry_and_hyperpigmented_4a5e5a1e4c.png",
                      },
                      204: {
                        label: "DRY & NON-HYPERPIGMENTED SKINSIZES",
                        image:
                          "https://stg-api.klira.skin/uploads/dry_and_nonhyperpigmented_6b508602e1.png",
                      },
                    };
                    product.isDayScript = true;
                    product.isSubscription = true;
                    product.imageUrl = 'https://klira.skin/wp-content/uploads/2025/09/kliraskinecomm-6830_V1__0002_Layer-Comp-3-1-scaled-1.png';
                }
                products.objects.push(product);
            });
        });

        availableCharges.forEach(function(charge) {
            let product = new KliraProduct();

            product.id = charge.identifier;
            product.isCharge = true;
            product.name = charge.name;
            product.price = charge.price;

            if (charge.charge_type === 'gift-card') {
                product.isGiftCard = true;
                product.isEachItemUnique = true;
                product.imageUrl = 'https://klira.skin/wp-content/uploads/2025/12/Gift-Card.png';
                product.canBuyMultiple = true;
            }

            if (charge.charge_type === 'video-consultation') {
                product.isVideoConsultation = true;
                product.imageUrl = 'https://klira.skin/wp-content/plugins/klira/assets/frontend/img/video-consultation.svg';
            }

            products.objects.push(product);
        });
    },

    getProductById(id) {
        let selectedProduct = null;
        console.log('Looking for product with ID ', id)

        this.objects.forEach(function (product) {
            if (product.isSubscription) {
                if (product.chargebeeAddOnId === id) {
                    selectedProduct = product;
                }
            } else if (product.isCharge) {
                if (product.id === id) {
                    selectedProduct = product;
                }
            }
        });

        console.log('Returning', selectedProduct)
        return selectedProduct;
    },

    getSelectedProductFromElement(addProductToCartElement) {
        console.log('Getting selected product from element', addProductToCartElement)
        const productId = addProductToCartElement.dataset.productId;

        if (!productId) {
            console.error('There is a no product ID attribute on the selected element');
            return;
        }

        console.log('Getting product with ID ', productId)

        return this.getProductById(productId);
    },
    getSelectedProduct() {
        // @TODO there should only be one way to do this
        // @TODO Remove #gift-card
        const btnSelected = document.querySelector('.add-product-to-cart, #gift-card, .product-options .elementor-widget-button.btn-active, .product-options input:checked, .selected-product');

        if (!btnSelected) {
            console.error('There is a no product input selected');
            return;
        }

        const productId = btnSelected.dataset.productId;

        if (!productId) {
            console.error('There is a no product ID attribute on the selected input');
            return;
        }

        console.log('Getting product with ID ', productId)

        return this.getProductById(productId);
    },

    setAdditionalField(selector, fieldName, retries = 5) {
        console.log(`PRODUCT: Setting additional field with selector ${selector} for field ${fieldName}`);
        let element = document.querySelector(selector)

        if (!element && retries === 0) {
            console.log(`PRODUCT: No more retries for setting additional field with selector ${selector} for field ${fieldName}`);
            return false;
        } else if (!element) {
            // reduce retries and try this again in 3 seconds
            console.log(`PRODUCT: Scheduling retry for setting additional field with selector ${selector} for field ${fieldName}`);
            retries--;
            setTimeout(this.setAdditionalField, 3000, selector, fieldName, retries);
        }

        element.dataset.productAdditionalField = fieldName;

        return true;
    },

    getAdditionalFields() {
        return document.querySelectorAll('[data-product-additional-field]');
    },

    getSelectedProductAdditionalFields() {
        // get all additional fields for the selected product
        const fields = this.getAdditionalFields();

        let additionalFields = {};

        fields.forEach(function(field) {
            window.utils.forms.removeErrorMessage(field);

            if (field.required && (!field.value || field.value.length === 0)) {
                window.utils.forms.addErrorMessage('This field is required', field);
                return;
            }

            // noinspection JSUnresolvedReference
            additionalFields[field.dataset.productAdditionalField] = field.value;
        });

        return additionalFields;
    },

    hasAdditionalFieldErrors() {
        // get all additional fields for the selected product
        const fields = this.getAdditionalFields();

        let foundErrors = false;

        fields.forEach(function(field) {
            if (window.utils.forms.hasErrorMessage(field)) {
                foundErrors = true;
            }
        });

        return foundErrors;
    }
}

window.products.load();